import { BaseControl, ControlProps } from "./BaseControl";
import { QuestionModel } from "../../models/QuestionModel";
import { ValidationResultModel } from "../../models/ValidationResultModel";
import { ValidationBuilder } from "../../models/builders/ValidationBuilder";
import { ValidationOptionsModel } from "../../models/ValidationOptionsModel";

export class NullControl extends BaseControl<any, any> {
    initializeQuestion(question: QuestionModel, props: ControlProps): void {}

    renderQuestion(question: QuestionModel): JSX.Element | null {
        return null;
    }

    validate(options?: ValidationOptionsModel): ValidationResultModel {
        return new ValidationBuilder().build();
    }
}
